import service = require("./breeze.entityManager.service");
import base = require("./base.dataservice");

export function initialize(module: ng.IModule) {
    module.service(CVCompetenceTypesService.Id, CVCompetenceTypesService);

    CVCompetenceTypesService.$inject = ["entityManagerService", "breeze", "$log", "$q"];
}

export class CVCompetenceTypesService extends base.BaseDataService<Nema.Crew.Model.CompetenceTypeCVMapping> {

    protected breeze;

    constructor(entityManagerService: service.EntityManagerService, breeze, $log, $q: ng.IQService) {
        super(entityManagerService, breeze, $log, $q);
    }

    public static Id: string = "cvCompetenceTypesService";

    protected get EntityName(): string {
        return "CompetenceTypeCVMapping";
    }

    protected get EntitiesName(): string {
        return "CompetenceTypeCVMappings";
    }

    public deleteRelatedEntities(entity: Nema.Crew.Model.CompetenceTypeCVMapping): Promise<void> {
        entity.CompetenceTypeCVMappingCompetenceGroups.forEach(step => (<breeze.Entity><any>step).entityAspect.entityState = this.breeze.EntityState.Deleted);
        entity.CompetenceTypeCVMappingCompetenceTypes.forEach(step => (<breeze.Entity><any>step).entityAspect.entityState = this.breeze.EntityState.Deleted);
        var deleteRelations = this.entityManager.saveChanges();

        return <Promise<void>><any>deleteRelations;
    }

    public newCompetenceGroupMapping(defaultCompetenceGroupId: number): Nema.Crew.Model.CompetenceTypeCVMappingCompetenceGroup {
        return <Nema.Crew.Model.CompetenceTypeCVMappingCompetenceGroup><any>this.entityManager.createEntity('CompetenceTypeCVMappingCompetenceGroup', <Nema.Crew.Model.CompetenceTypeCVMappingCompetenceGroup>{
            CompetenceGroupId: defaultCompetenceGroupId
        });
    }
    
    public newCompetenceTypeMapping(defaultCompetenceTypeId: number): Nema.Crew.Model.CompetenceTypeCVMappingCompetenceType {
        return <Nema.Crew.Model.CompetenceTypeCVMappingCompetenceType><any>this.entityManager.createEntity('CompetenceTypeCVMappingCompetenceType', <Nema.Crew.Model.CompetenceTypeCVMappingCompetenceType>{
            CompetenceTypeId: defaultCompetenceTypeId
        });
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/cvcompetencetypes.dataservice.ts